export default __webpack_public_path__ + "static/media/facebook.71b6428a.png";